import React from "react";
import { useHistory } from "react-router";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";
import { TextField } from "@syos-music/form";

import { Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation ($name: String!) {
    CreateTemplate(name: $name) {
      template {
        id
      }
    }
  }
`;

export default function CreateTemplateDialog({ classes, children }) {
  const history = useHistory();
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [createTemplate] = useMutation(MUTATION);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={(values) =>
            createTemplate({ variables: values })
              .then(({ data }) => {
                close();
                history.push(
                  `/admin/templates/${data.CreateTemplate.template.id}`
                );
              })
              .catch(() => true)
          }
          initialValues={{}}
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting, invalid, pristine, form }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">Créer un template</Dialog.Title>

              <Dialog.Content>
                <TextField name="name" label="Nom" required />
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton
                  type="submit"
                  loading={submitting}
                  disabled={pristine}
                >
                  Créer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}
